module.exports = __webpack_public_path__ + "static/img/02450_2.9e8d842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_2.jpg
// module id = lGEY
// module chunks = 1